export class MinMaxRange {
    constructor(
      public min?: number | null,
      public max?: number | null
    ) {}
  }